/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FoodSourceDto } from '../../models/food-source-dto';

export interface ApiFoodsourceGet$Params {
  'api-version'?: string;
}

export function apiFoodsourceGet(http: HttpClient, rootUrl: string, params?: ApiFoodsourceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FoodSourceDto>>> {
  const rb = new RequestBuilder(rootUrl, apiFoodsourceGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FoodSourceDto>>;
    })
  );
}

apiFoodsourceGet.PATH = '/api/foodsource';
